// extracted by mini-css-extract-plugin
export default {"ConfirmPopUp":"ConfirmPopUp_ConfirmPopUp__fR1n4"};